<template>
  <section v-if="list.length" class="mt-5">
    <div class="row no-gutters">
      <div class="col pl-3 list-heading">
        {{ $t('reports.trip-reports-search.service-code') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.trip-reports-search.number-of-items') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.trip-reports-search.category') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.trip-reports-search.price') }}
      </div>
      <!-- <div class="col pl-3 list-heading">
        {{ $t('reports.trip-reports-search.ledger-code') }}
      </div> -->
    </div>
    <ul class="row input-table mt-2">
      <reports-trip-reports-list-item
        v-for="(report, index) in list"
        :key="index"
        :item="report"
      ></reports-trip-reports-list-item>
    </ul>
  </section>
</template>
<script>
export default {
  props: {
    list: {
      default: () => [],
      type: Array,
      required: false
    }
  }
}
</script>

<style scoped>
.list-heading {
  font-family: 'Open Sans Bold';
  font-size: 14px;
  color: #767676;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/trip-reports/List.vue